let bonusDeals = [];

function updateTotals(data) {

    if (data.count == 1) {
        $('.cart-items-count').html(data.count + " " + $('.cart-items-count').data('single'));
    } else {
        $('.cart-items-count').html(data.count + " " + $('.cart-items-count').data('multiple'));
    }

    $('.total-items').removeClass('d-none');
    $('.border-dashed').removeClass('d-none');
    if (data.totals.discount.price === false) {
        $('.total-items').addClass('d-none');
        $('.border-dashed').addClass('d-none');
    }
    
    let totalSaved = config.webshop.type == 'B2C'
        ? data.totals.total.save_incl
        : data.totals.total.save_excl;

    $('.total-items-incl').html(getLocalePrice(data.totals.items.incl));
    $('.total-excl').html(getLocalePrice(data.totals.total.excl));
    $('.total-incl').html(getLocalePrice(data.totals.total.incl));
    $('.save-incl').html(getLocalePrice(data.totals.total.save_incl));
    $('.save-total').html('<i>'+getLocalePrice(totalSaved)+'</i>');
    $('.cart-price-total').html(getLocalePrice(data.totals.total.incl));

    if (totalSaved <= 0) {
        $('.save-total').parent().addClass('d-none');
    } else {
        $('.save-total').parent().removeClass('d-none');
    }

    if ($('.total-vat-low').length > 0) {
        $('.total-vat-low').html(getLocalePrice(data.totals.vat.low));
    }
    if ($('.total-vat-high').length > 0) {
        $('.total-vat-high').html(getLocalePrice(data.totals.vat.high));
    }

    let shipmentPrice = config.webshop.type == 'B2C'
        ? data.totals.shipment.incl
        : data.totals.shipment.excl;

    if (shipmentPrice !== 0) {
        shipmentPrice = getLocalePrice(shipmentPrice)
        $('.total-shipment .total-shipment-value').html(shipmentPrice);
    } else {
        $('.total-shipment .total-shipment-value').html($('.total-shipment-text').data("text-free"));
    }


    $('.total-discount').addClass('d-none');
    $('.total-discount-value').html(getLocalePrice(0));
    if (data.totals.discount.price !== false) {
        $('.total-discount').removeClass('d-none');
        $('.total-discount-text').html($('.total-discount-text').data('text'));
        if (data.totals.discount.type == 'percentage') {
            $('.total-discount-text').html($('.total-discount-text').data('text') + " (" + data.totals.discount.discount + "%)");
        }
        $('.total-discount-value').html("-" + getLocalePrice(data.totals.discount.price));
    }

    if(config.bonus_deals.enabled) {

        let key = "excl";
        if (config.webshop.type == "B2C") {
            key = "incl"
        }
        
        let previousIsShowing = false;
        bonusDeals.forEach(deal => {

            let total = data.totals.items[key] - data.totals.discount.price ?? 0;

            deal.setTotal(total);

            if(previousIsShowing || deal.is_complete) {
                deal.hide();
            }

            if(deal.is_visible && !deal.is_complete) {
                previousIsShowing = true;
            }

        });
    }

}
function updateCart(data) {

    $.each(data.cartItemPrices, function (index, value) {
        $('.list-item[data-id="' + index + '"]').find('.area-price .price').html(getLocalePrice(value.price));
        $('.list-item[data-id="' + index + '"]').find('.area-price .price-from-strike').html("");
    });
}

if(config.bonus_deals.enabled) {
    
    let previousIsShowing = false;
    $('.card-bonus-deals').each(function(index) {

        $(this).attr('index', index);

        let deal = new BonusDeal($(this));

        deal.index = index;

        if(previousIsShowing || deal.is_complete) {
            deal.hide();
        }

        if(deal.is_visible && !deal.is_complete) {
            previousIsShowing = true;
        }

        deal.on('completed', function(totals) {
            bonusDeals[index+1]?.show();
            // $('.shoppingcart-body').append(cartRow);

            reloadProducts();
            updateTotals(totals);
            
        }); 
        
        deal.on('regress', function() {
            reloadProducts();
        });

        bonusDeals.push(deal)
    });
}

function reloadProducts() {
    $('.shoppingcart-body').load(location.href + ' .shoppingcart-body');
}

$(document).ready(function () {

    let cartItemUpdateTimer = null;
    $(document).on('focus', '.list-item input[name=amount]', function (e) {
        $(this).data('prev-value', $(this).val());
    });

    $(document).on('input change', '.list-item input[name=amount]', function (e) {
        let item = $(this).closest('.list-item');

        let amount = inputDigits($(this).val());

        let selector = `.list-item[data-gift_parent_id*=",${item.data('id')},"]`;
        
        let oldValue = parseInt($(this).data('prev-value'));
        let value = parseInt($(this).val());

        $(selector).each(function() {
            let oldAmount = parseInt($(this).find('.area-quantity').html());
            let amount = parseInt(oldAmount) + (value - oldValue);
            $(this).find('.area-quantity').html(amount);
            let giftItemPrice = $(this).data('gift-item-price');
            $(this).find('.price-from-strike').html(getLocalePrice(giftItemPrice * amount));
        });

        $(this).data('prev-value', parseInt($(this).val()));

        if(cartItemUpdateTimer) {
            clearTimeout(cartItemUpdateTimer);
        }

        cartItemUpdateTimer = setTimeout(function(){
            $.ajax({
                url: config.domain + "/frontend/functions/cart_item_update.php?action=1",
                type: "POST",
                dataType: "json",
                data: {
                    "id": item.data('id'),
                    "amount": amount
                },
                success: function (data) {
                    if (typeof data.item != 'undefined') {
                        item.find('.area-price .price').html((config.webshop.type == 'B2C'
                            ? getLocalePrice(data.item.pricing.primary_discount)
                            : getLocalePrice(data.item.price_excl_total)));
                        const priceTotal = (config.webshop.type == 'B2C')
                            ? data.item.price_incl_total
                            : data.item.price_excl_total;
                        const currentTotal = (config.webshop.type == 'B2C')
                            ? parseFloat(data.item.pricing.primary_discount)
                            : parseFloat(data.item.price_excl_total);
                        const priceFrom = (config.webshop.type == 'B2C')
                            ? data.item.price_from_incl
                            : data.item.price_from_excl;
                        const hasPriceFrom = priceFrom !== null && priceFrom !== undefined && parseFloat(priceFrom) !== 0;
                        const hasDiscount = parseFloat(data.item.pricing.primary_discount) !== parseFloat(data.item.pricing.primary);
                        let strikeTotal = null;

                        if (hasPriceFrom) {
                            strikeTotal = priceFrom * data.item.quantity;
                        } else if (hasDiscount) {
                            strikeTotal = priceTotal;
                        }

                        if (strikeTotal !== null) {
                            const strikeValue = parseFloat(strikeTotal);
                            if (!isFinite(strikeValue) || !isFinite(currentTotal) || strikeValue <= currentTotal) {
                                strikeTotal = null;
                            } else {
                                strikeTotal = strikeValue;
                            }
                        }

                        let strikeElem = item.find('.area-price .price-from-strike');
                        if (strikeTotal !== null) {
                            if (strikeElem.length === 0) {
                                item.find('.area-price').append('<span class="price-from-strike"></span>');
                                strikeElem = item.find('.area-price .price-from-strike');
                            }
                            strikeElem.html(getLocalePrice(strikeTotal));
                        } else if (strikeElem.length > 0) {
                            strikeElem.remove();
                        }
                        $('.cart-amount').text(data.count);
        
                        updateTotals(data);
                        updatePromotionCode(data);
                    }
                }
            }, 200);

        });
    });

  
});